import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { toUserSelectItem } from '../../../../../User'
import {
  TASK_FORM_MANAGER_FIELD_NAME,
  TASK_FORM_PHASE_FIELD_NAME,
  TASK_FORM_SERVICE_REQUEST_FIELD_NAME,
} from '../../../TaskForm.constants'

export function useServiceRequestFieldChange({
  currentUser,
  setEmails,
  setPhaseItems,
}) {
  const { setFieldValue, touched, values } = useFormikContext()

  useEffect(() => {
    if (touched[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]) {
      // Clear phase values if service request changed
      setPhaseItems(null)
      setEmails([])
      setFieldValue(TASK_FORM_PHASE_FIELD_NAME, null)

      const hasManager = values[TASK_FORM_MANAGER_FIELD_NAME]

      if (!hasManager && currentUser) {
        setFieldValue(
          TASK_FORM_MANAGER_FIELD_NAME,
          toUserSelectItem(currentUser)
        )
      }
    }
  }, [currentUser, values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]?.value])
}
